export default __webpack_public_path__ + "static/media/aces-logo.8a28ce85.png";